import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from '../store';

export type CacheSliceType = {
  // puzzleLevelCache: string;
  [key: string]: string;
};

const initialState: CacheSliceType = {
  // puzzleLevelCache: JSON.stringify({
  //   start_index: 0, list: [], current_level: 1, images: [], total: 0
  // })
};

const slice = createSlice({
  name: 'Cache',
  initialState,
  reducers: {
    // setPuzzleLevelCache(
    //   state: CacheSliceType, action: PayloadAction<string>
    // ) {
    //   state.puzzleLevelCache = action.payload;
    // },
    // store data under different themes
    setCustomeCache(
      state: CacheSliceType, action: PayloadAction<{id: string, value: string}>
    ) {
      state[action.payload.id] = action.payload.value;
    }
  },
});

export const {
  // setPuzzleLevelCache,
  setCustomeCache
} = slice.actions;

export const selectTool = createSelector(
  [(state: RootState) => state.cache],
  (state) => state
);

export default slice.reducer;